import { useTheme } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ChatbotBusinesses } from './ChatbotBusinesses/ChatbotBusinesses';
import { getChatbotLicenceBusinessessThunk } from './store/thunks/chatbotAnalyticsThunks';

export const ChatbotAnalytics = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  //   const chatbotControlData = useSelector(getChatbotControlData);

  //   const toggleChatBot = () => {
  //     dispatch(toggleOpenCloseChatBot());
  //   };

  useEffect(() => {
    dispatch(getChatbotLicenceBusinessessThunk());
  }, []);

  return <ChatbotBusinesses></ChatbotBusinesses>;
};
